// TODO : looks like we do not use it - we can remove this 2 consts
export const GET_STUDIO_CONFIG_REQ = 'GET_STUDIO_CONFIG_REQ';
export const GET_STUDIO_CONFIG_OK = 'GET_STUDIO_CONFIG_OK';

export const GET_VOICES_CONFIG_REQ = 'GET_VOICES_CONFIG_REQ';
export const GET_VOICES_CONFIG_OK = 'GET_VOICES_CONFIG_OK';

export const GET_WAKEWORD_ACUSTIC_MODELS_CONFIG_REQ = 'GET_WAKEWORD_ACUSTIC_MODELS_CONFIG_REQ';
export const GET_WAKEWORD_ACUSTIC_MODELS_CONFIG_OK = 'GET_WAKEWORD_ACUSTIC_MODELS_CONFIG_OK';

export const GET_SLU_VERSION_CONFIG_REQ = 'GET_SLU_VERSION_CONFIG_REQ';
export const GET_SLU_VERSION_CONFIG_OK = 'GET_SLU_VERSION_CONFIG_OK';

export const GET_FEATURES_CONFIG_REQ = 'GET_FEATURES_CONFIG_REQ';
export const GET_FEATURES_CONFIG_OK = 'GET_FEATURES_CONFIG_OK';
